<template>
  <div class="form-group mb-0" :class="{'mt-3': index > 0}">
    <div class="row">
      <div class="col-sm-12">
        <span style="font-weight: 600; font-size: 130%;">
          {{ $t('configurator.form.labels.single_surface') }}: {{ inEnglish ? refinement.name_en : refinement.name }}
        </span>
      </div>
    </div>
  </div>

  <div class="form-group">
    <label for="article_id" class="control-label">{{ $t('configurator.form.labels.print_article') }}:</label>
    <div class="row">
      <div class="col-sm-12">
        <multiselect v-model="form.article"
          :placeholder="t('configurator.form.placeholders.please_select')"
          label="name"
          track-by="id"
          :options="availableArticles"
          :option-height="104"
          :custom-label="customLabel"
          :show-labels="false">
          <template #singleLabel="props">
            <span class="booth-draft__font">{{ !inEnglish ? props.option.article.name : props.option.article.name_en }}</span>
          </template>
          <template #option="props">
            <booth-refinement-print-article-option
              :article="props.option.article"
              :is-configurator="true">
            </booth-refinement-print-article-option>
          </template>
          <template #noOptions>
            {{ $t('configurator.form.labels.no_options_last_minute') }}
          </template>
        </multiselect>
        <span v-if="form.errors.has('article')" class="text-danger">
          <span v-if="availableArticles.length > 0">
             {{ $t('configurator.form.labels.no_options') }}
          </span>
          <span v-else>
             {{ $t('configurator.form.labels.no_options_last_minute') }}
          </span>
        </span>
      </div>
    </div>
  </div>

  <div v-if="!form.is_logo_print && form.article !== null" class="form-group">
    <label class="control-label" for="label">
      {{ $t('configurator.form.labels.lettering') }}:
    </label>
    <input
      id="label"
      key="input-label"
      class="form-control input-sm"
      type="text"
      name="label"
      v-model.trim="form.label">
    <span v-if="form.errors.has('label')" class="text-danger">
      {{ $t('configurator.form.errors.lettering') }}
    </span>
  </div>

  <div v-show="form.is_logo_print && form.article !== null" class="form-group">
    <p>{{ $t('configurator.descriptions.upload_files_later') }}</p>
  </div>
</template>

<script setup>
import Form from '@/classes/Form'
import Multiselect from 'vue-multiselect'
import { ARTICLE_TYPE_PRINT } from '@/constants'
import { useI18n } from 'vue-i18n'
import { useMainStore } from '@/store'
import { computed, watch } from 'vue'
import { filterAvailableBoothRefinementArticles } from '@/utils/boothRefinements'

const { t } = useI18n({ useScope: 'global' })
const store = useMainStore()
// props
const props = defineProps({
  index: {
    type: Number,
    required: true,
  },
  form: {
    type: Form,
    required: true,
  },
  refinement: {
    type: Object,
    required: true
  }
})

// computed properties
const inEnglish = computed(() => store.inEnglish)
const disabledBoothRefinementArticleIds = computed(() => store.availability.disabled_booth_refinement_ids)
const bookableArticleIds = computed(() => store.availability.bookable_article_ids)

const availableArticles = computed(() => {
  return filterAvailableBoothRefinementArticles(
    props.refinement.articles,
    disabledBoothRefinementArticleIds.value,
    bookableArticleIds.value
  )
})

// define watch
watch(() => props.form.article, () => {
  if (props.form.article === null) {
    props.form.is_logo_print = false

    return
  }

  const index = props.form.refinements[0].articles.findIndex((article) => {
    return article.article_id === props.form.article.article.id
  })

  if (index > -1) {
    props.form.is_logo_print = (props.form.refinements[0].articles[index].article.type === ARTICLE_TYPE_PRINT)
  }
})

// methods
const customLabel = ({name, description}) => {
  return '${title} - ${description}'
}
</script>